import { render } from "./BusinessRegister2.vue?vue&type=template&id=be865340&scoped=true"
import script from "./BusinessRegister2.vue?vue&type=script&lang=js"
export * from "./BusinessRegister2.vue?vue&type=script&lang=js"

import "./BusinessRegister2.vue?vue&type=style&index=0&id=be865340&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be865340"]])

export default __exports__